import Alpine from 'alpinejs'
import $ from 'jquery'

export default () => {
	Alpine.magic(
		'get',
		() => async (url: string, data?: object) =>
			$.nette.ajax({
				method: 'get',
				url,
				dataType: 'json',
				data: data || {},

				complete: (payload) => payload.responseJSON,

				error: (payload) => {
					// eslint-disable-next-line no-console
					console.error(payload.statusText)
					return {}
				},
			}),
	)

	Alpine.magic(
		'post',
		() => async (url: string, data?: object) =>
			$.nette.ajax({
				method: 'post',
				url,
				dataType: 'json',
				data: data || {},

				complete: (payload) => payload.responseJSON,

				error: (payload) => {
					// eslint-disable-next-line no-console
					console.error(payload.statusText)
					return {}
				},
			}),
	)

	Alpine.directive('template-outlet', (element, metadata, framework) => {
		const templateRef = framework.evaluate(metadata.expression)
		// @ts-ignore
		const clone = templateRef.content.cloneNode(true).firstElementChild
		Alpine.addScopeToNode(clone, Alpine.closestDataStack(element)[0], element.parentElement)
		const domHook = document.createComment(
			` Template outlet hook (${metadata.expression}) with bindings (${element.getAttribute('x-data')}). `,
		)
		// @ts-ignore
		domHook._template_outlet_ref = templateRef
		// @ts-ignore
		domHook._template_outlet_clone = clone
		Alpine.mutateDom(() => {
			element.after(domHook)
			domHook.after(clone)
			Alpine.initTree(clone)
			element.remove()
			Alpine.destroyTree(element)
		})
	})
}
